<template>
    <div class="st-note-transcript" :class="{ 'dark-theme': shouldUseDarkTheme }"
        :data-theme="shouldUseDarkTheme ? 'dark' : 'light'">
        <!-- 移动端操作按钮 -->
        <div class="st-mobile-action-buttons" v-if="isMobile && transcript.type !== 'record'">
            <button class="st-mobile-action-btn" @click="copytext()" title="Copy as Text">
                <i class="el-icon-tickets"></i>
            </button>
        </div>
        <div class="st-mobile-action-buttons" v-if="isMobile && transcript.type == 'record'">
            <button class="st-mobile-action-btn" @click="copytranscript('text')" title="Copy as Text">
                <i class="el-icon-tickets"></i>
            </button>
        </div>
        <div ref="contentToDownload" class="st-transcripts">
            <div class="st-transcript-actions" v-if="!loading">
                <div class="st-desktop-actions" v-if="!isMobile">
                    <el-dropdown class="st-export" v-if="transcript.type !== 'record'" @command="handleCommand">
                        <span class="el-dropdown-link">
                            Copy as<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="copytext" icon="el-icon-tickets">Copy as TXT</el-dropdown-item>
                            <el-dropdown-item command="downloadaspdf" icon="el-icon-download">Download as
                                PDF</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown class="st-export" v-if="transcript.type == 'record'" @command="handleCommand">
                        <span class="el-dropdown-link">
                            Copy as<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="copytext-rr" icon="el-icon-tickets">Copy as
                                TXT</el-dropdown-item>
                            <el-dropdown-item command="downloadaspdf-rr" icon="el-icon-download">Download as
                                PDF</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <pre v-if="transcript.type != 'record'">{{ transcript.value }}</pre>
            <div class="st-alltextbox" v-if="transcript.type == 'record'" :class="{ 'st-mobile-view': isMobile }">
                <div v-if="transcript.value?.text_objs" class="st-record-content">
                    <div class="st-left-text" ref="left_text">
                        <div class="st-textbox" v-for="(textobj, i) in transcript.value?.text_objs" :key="i">
                            <h5>{{ textobj.time }}</h5>
                            <div class="st-yuantext">{{ textobj.text }}</div>
                            <div class="st-translatetext"> {{ textobj.trans }}</div>
                        </div>
                    </div>
                </div>
                <div v-else class="st-record-content">
                    <div class="st-textbox" v-for="(textobj, i) in transcript.value" :key="i">
                        <h5>{{ textobj.time }}</h5>
                        <div class="st-yuantext">{{ textobj.text }}</div>
                        <div class="st-translatetext"> {{ textobj.trans }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
export default {
    props: {
        transcript: {
            type: Object,
            default: () => ({
                // 这里填入默认对象的属性
            }),
        },
    },
    name: "NoteTranscript",
    data() {
        return {
            currentTheme: 'light',
            noteTitle: "Lawful Interception in Telecommunications Networks Overview",
            isPublic: true,
            dateUploaded: "2024-07-12",
            classSubject: "Computer Science",
            isDarkTheme: true,
            isSharePage: false,
            isMobile: false,
            loading: false,

            md: new MarkdownIt({
                html: true,
                linkify: true,
                typographer: true,
                highlight: function (str, lang) {
                    if (lang && hljs.getLanguage(lang)) {
                        try {
                            return hljs.highlight(lang, str).value;
                        } catch (__) {
                            console.log("error", str, lang);
                        }
                    }
                    return ""; // 使用默认的转义
                },
            }),
        };
    },
    computed: {
        shouldUseDarkTheme() {
            // 优先使用组件内部的主题状态
            return this.currentTheme === 'dark';
        }
    },
    created() {
        if (this.transcript.type == "record") {
            this.markdowntext()
        }

        // 检测是否在共享页面
        this.isSharePage = this.detectIfSharePage();
    },
    mounted() {
        // 初始化主题
        const savedTheme = localStorage.getItem('easynote-transcript-theme');
        if (savedTheme) {
            this.currentTheme = savedTheme;
        } else {
            // 从父组件或全局主题设置中获取初始主题
            const globalTheme = localStorage.getItem('easynote-theme-preference');
            this.currentTheme = globalTheme === 'dark' ? 'dark' : 'light';
        }

        // 检测是否为移动端
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);
    },
    methods: {
        detectIfSharePage() {
            // 通过检测父组件的name来判断是否在共享页面
            let parentComponent = this.$parent;
            while (parentComponent) {
                if (parentComponent.$options.name === 'ShareNotesPage') {
                    return true;
                }
                parentComponent = parentComponent.$parent;
            }
            return false;
        },
        onThemeChange(isDarkTheme) {
            const newTheme = isDarkTheme ? 'dark' : 'light';
            
            // 如果主题未变化，则不处理
            if (this.currentTheme === newTheme) {
                return;
            }
            
            this.currentTheme = newTheme;
            
            // 保存主题设置到localStorage
            localStorage.setItem('easynote-transcript-theme', this.currentTheme);
            localStorage.setItem('easynote-theme-preference', isDarkTheme ? 'dark' : 'light');
            
            // 强制更新组件
            this.$forceUpdate();
        },
        markdowntext() {
            this.$nextTick(() => {
                this.transcript.value?.part_objs.forEach((item) => {
                    item.notes = this.md.render(item.notes);
                });
            });
        },
        deleteNotes() {
            // 实现删除笔记的逻辑
            console.log("Deleting notes...", this.transcript);
        },
        copytranscript(what) {
            let copyContent = '';
            let htmlContent = '';
            switch (what) {
                case 'part':
                    copyContent = this.transcript?.value?.part_objs
                        .map((item) => item.notes)
                        .join('\n');
                    break;
                case 'part-text':
                    htmlContent = this.transcript?.value?.part_objs
                        .map((item) => item.mk_notes)
                        .join('');
                    console.log("htmlContent", htmlContent);
                    copyContent = this.htmlToText(htmlContent);
                    break;
                case 'text':
                    copyContent = this.transcript?.value?.text_objs
                        .map((item) => item.text)
                        .join('\n');
                    break;
            }
            this.$message({ message: "Transcript copied to clipboard", type: "success" });
            this.copyToClipboard(copyContent);
        },
        handleCommand(command) {
            switch (command) {
                case "copymarkdown":
                    this.copymarkdown();
                    break;
                case "copytext":
                    this.copytext();
                    break;
                case "downloadaspdf":
                    this.downloadaspdf();
                    break;
                case "noteshare":
                    this.noteshare();
                    break;
                case "copytext-rr":
                    this.copytranscript('text');
                    break;
                case "downloadaspdf-rr":
                    this.downloadaspdf('left_text');
                    break;
                // 支持新的命令格式
                case "copyRaw":
                    this.copytext();
                    break;
                case "copyFormatted":
                    this.copyFormattedText();
                    break;
                case "downloadPDF":
                    this.downloadaspdf();
                    break;
                default:
                    break;
            }
        },
        copymarkdown() {
            console.log("copymarkdown", this.notes);
            const markdownContent = this.notes.mk_notes;
            this.copyToClipboard(markdownContent);
            this.$message({ message: "Copied to clipboard", type: "success" });
        },
        copytext() {
            if (this.transcript.type != "record") {
                const textContent_a = this.transcript.value;
                this.copyToClipboard(textContent_a);
                this.$message({ message: "Transcript copied to clipboard", type: "success" });
                this.showCopiedEffect();
            } else {
                const textContent_r = this.formattedText(this.transcript.value)
                this.copyToClipboard(textContent_r);
                this.$message({ message: "Transcript copied to clipboard", type: "success" });
                this.showCopiedEffect();
            }
        },
        formattedText(data) {
            return data
                .map(item => `${item.time} ${item.text}`)
                .join('\n');
        },
        downloadaspdf(resobj) {
            this.printPdf(resobj);
        },
        async printPdf(resobj) {
            try {
                // 获取打印容器
                const printContainer = this.$refs[resobj];
                if (!printContainer || !printContainer.innerHTML.trim()) {
                    throw new Error('No content to print');
                }

                // 创建一个隐藏的 iframe
                const iframe = document.createElement('iframe');
                iframe.style.position = 'absolute';
                iframe.style.top = '-9999px';
                iframe.style.left = '-9999px';
                document.body.appendChild(iframe);

                // 将打印容器的内容复制到 iframe 中
                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
                iframeDocument.open();
                iframeDocument.write(`
      <html>
        <head>
          <title>打印内容</title>
          <style>
            /* 添加你需要的样式 */
            body {
              font-family: Arial, sans-serif;
            }
            .print-container {
              padding: 20px;
            }
            ${this.getAdditionalStyles()} /* 获取额外需要的样式 */
          </style>
        </head>
        <body>
          ${printContainer.innerHTML}
        </body>
      </html>
    `);
                iframeDocument.close();

                // 等待 iframe 加载完成
                await new Promise((resolve) => {
                    iframe.onload = resolve;
                });

                // 等待一小段时间，确保所有内容都已渲染
                await new Promise((resolve) => setTimeout(resolve, 1000));

                // 调用浏览器的打印功能
                iframe.contentWindow.print();

                // 移除 iframe
                document.body.removeChild(iframe);
            } catch (error) {
                console.error('PDF打印失败:', error);
                alert('PDF打印失败，请稍后重试或联系支持人员。');
            }
        },
        noteshare() {
            console.log("noteshare", this.transcript);
            const shareurl = 'https://www.easynoteai.com/share?t=' + this.transcript.notetoken;
            this.copyShareToClipboard(shareurl);
        },
        copyShareToClipboard(text) {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(() => {
                    this.$message({ message: "Share link copied to clipboard", type: "success" });
                }).catch((err) => {
                    console.error('Could not copy text: ', err);
                });
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    this.$message({ message: "Share link copied to clipboard", type: "success" });
                } catch (err) {
                    console.error('Could not copy text: ', err);
                }
                document.body.removeChild(textArea);
            }
        },
        getAdditionalStyles() {
            // 这里可以返回任何额外需要的CSS
            return `
      /* 额外的CSS样式 */
      .custom-class {
        color: #333;
      }
    `;
        },
        copyToClipboard(text) {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(() => {
                    // 复制成功,但不触发额外提示,只依靠上面的$message
                }).catch((err) => {
                    console.error('Could not copy text: ', err);
                });
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    // 复制成功,但不触发额外提示,只依靠上面的$message
                } catch (err) {
                    console.error('Could not copy text: ', err);
                }
                document.body.removeChild(textArea);
            }
        },
        checkIfMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        showCopiedEffect() {
            // 为移动端按钮添加一个短暂的复制成功效果
            if (this.isMobile) {
                const btn = document.querySelector('.st-mobile-action-btn');
                if (btn) {
                    btn.classList.add('copied');
                    setTimeout(() => {
                        btn.classList.remove('copied');
                    }, 800);
                }
            }
        },
    },
    beforeDestroy() {
        // 移除事件监听
        window.removeEventListener('resize', this.checkIfMobile);
    }
};
</script>

<style lang="less" scoped>
/* CSS变量 - 浅色主题 */
:root {
    --text-color: #2c3e50;
    --text-light: #5c6b7f;
    --border-color: #e6e8ed;
    --shadow-color: rgba(0, 0, 0, 0.08);
    --card-bg: #ffffff;
    --button-bg: #f8f9fa;
    --button-text: #2c3e50;
    --button-hover-bg: #e9ecef;
    --toggle-color: #2c3e50;
    --toggle-hover-bg: rgba(0, 0, 0, 0.05);
    --tooltip-bg: #ffffff;
    --tooltip-text: #2c3e50;
    --progress-bg: #e9ecef;
    --th-bg: #f8f9fa;
    --link-color: #0366d6;
    --code-bg: #f8f9fa;
    --pre-bg: #f8f9fa;
    --pre-text: #2c3e50;
    --blockquote-color: #5c6b7f;
    --primary-color: #4a6bff;
    --primary-hover: #3955d1;
    --record-card-bg: #ffffff;
    --record-time-color: #5c6b7f;
    --record-text-bg: #f8f9fa;
    --record-trans-bg: #f1f3f5;
}

/* 深色主题的CSS变量 */
.dark-theme,
[data-theme="dark"] {
    --text-color: #e9ecef;
    --text-light: #adb5bd;
    --border-color: #495057;
    --shadow-color: rgba(0, 0, 0, 0.3);
    --card-bg: #212529;
    --button-bg: #343a40;
    --button-text: #e9ecef;
    --button-hover-bg: #495057;
    --toggle-color: #e9ecef;
    --toggle-hover-bg: rgba(255, 255, 255, 0.1);
    --tooltip-bg: #343a40;
    --tooltip-text: #e9ecef;
    --progress-bg: #343a40;
    --th-bg: #2b3035;
    --link-color: #58a6ff;
    --code-bg: #2b3035;
    --pre-bg: #2b3035;
    --pre-text: #e9ecef;
    --blockquote-color: #adb5bd;
    --primary-color: #5d6fff;
    --primary-hover: #4a5ce0;
    --record-card-bg: #2b3035;
    --record-time-color: #adb5bd;
    --record-text-bg: #343a40;
    --record-trans-bg: #2b3035;
}

.st-note-transcript {
    margin: 10px auto;
    font-family: 'Arial', sans-serif;
    max-width: 95%;
    color: var(--text-color, #333333);
    transition: color 0.3s ease, background-color 0.3s ease;
    max-height: calc(100vh - 150px);
    overflow: auto;
    position: relative;
    border-radius: 8px;
    padding: 20px;
    position: relative;
    .st-export {
        position: absolute;
        top: 10px;
        right: 20px;
        cursor: pointer;
        padding: 10px 20px;
        border-radius: 5px;
        color: var(--button-text, #333333);
        transition: background-color 0.3s ease, color 0.3s ease;
        background: var(--button-bg, #f0f0f0);
        &:hover {
            background: var(--button-hover-bg, rgba(230, 230, 230, 0.9));
        }
    }

    h1 {
        font-size: 36px;
        margin: 0;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        color: var(--text-color, #333333);
        transition: color 0.3s ease;

        i {
            margin-right: 10px;
            font-size: 44px;
        }
    }
}

.st-transcript-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
}

/* 移动端样式 */
@media (max-width: 768px) {
    .st-desktop-actions {
        display: none !important;
    }

    .st-mobile-action-buttons {
        display: flex !important;
    }

    .st-note-transcript {
        max-width: 100%;
        margin: 0;
        padding: 0 15px;
        max-height: none;

        h1 {
            padding-right: 50px;
            font-size: 24px;
            margin-top: 10px;
        }
    }

    .st-transcripts {
        margin-bottom: 30px;
        
        pre {
            font-size: 16px;
            line-height: 24px;
            word-break: break-word;
        }
    }

    .st-alltextbox {
        .st-left-text {
            margin-right: 0;
            height: auto;
            max-height: none;
        }

        .st-textbox {
            margin-bottom: 15px;

            .st-yuantext {
                padding: 15px;
            }
        }
    }

    .el-icon-download,
    [command="downloadaspdf"] {
        display: none !important;
    }
}

.st-transcripts {
    pre {
        white-space: pre-wrap;
        line-height: 1.6;
        font-size: 16px;
        color: var(--pre-text);
        padding: 20px 0;
        margin: 0;
        border-radius: 8px;
    }
}

.st-record-content {
    width: 100%;
    background-color: transparent;
    transition: background-color 0.3s ease;
}

.st-alltextbox {
    border-radius: 8px;
    display: flex;
    background-color: transparent;

    .st-left-text {
        flex: 1;
        margin-right: 10px;
        background-color: transparent;
    }

    .st-textbox {
        font-size: 16px;
        border-radius: 8px;
        margin-bottom: 15px;
        overflow: hidden;

        h5 {
            margin: 0;
            text-align: center;
            color: var(--record-time-color);
            padding: 12px 0;
        }

        .st-yuantext {
            font-family: 'Arial', sans-serif;
            line-height: 1.6;
            padding: 20px 0;
            color: var(--text-color);
            border-bottom: 1px solid var(--border-color);
        }

        .st-translatetext {
            margin: 0;
            color: var(--text-light);
            padding: 20px;
        }
    }
}

.st-note-header {
    display: none;
}

.st-mobile-actions {
    display: none;
}

.st-mobile-action-buttons {
    display: none;
    position: fixed;
    top: 220px;
    right: 20px;
    gap: 10px;
    z-index: 300;
}

.st-mobile-action-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: var(--primary-color, #4a6bff);
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 2px 8px var(--shadow-color, rgba(0, 0, 0, 0.2));

    &:hover,
    &:active {
        transform: scale(1.05);
        background-color: var(--primary-hover, #3955d1);
    }

    &.copied {
        background-color: #34c759;
        animation: pulse 0.8s;
    }

    i {
        font-size: 20px;
    }
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
    }
}

.st-alltextbox.st-mobile-view {
    flex-direction: column;

    .st-left-text {
        margin-bottom: 20px;
        border-radius: 8px;
    }
}

@media (max-width: 768px) {
    .st-alltextbox {
        padding: 0;
    }
}

/* 添加移动端复制按钮下移样式 */
@media (max-width: 768px) {
    .st-mobile-action-buttons {
        top: 250px !important;
    }

    .st-note-transcript {
        padding-bottom: 80px !important;
        
        .st-transcripts {
            margin-bottom: 80px !important;

            pre {
                padding-bottom: 60px !important;
            }
        }

        .st-alltextbox {
            padding-bottom: 80px !important;

            .st-left-text {
                height: calc(100vh - 280px) !important;
                padding-bottom: 60px !important;
            }
        }
    }
}
</style>